<template>
    <DefaultLayout :title="__('admin::general.edit_model', {'model': __('admin::projects.project').toLowerCase() })">

        <template #title>
            <InertiaLink :href="$route('admin::projects.index')">{{ __('admin::projects.projects') }}</InertiaLink>
            <ChevronRightIcon class="w-6 h-6 inline align-text-top text-gray-300" />
            {{ project.name }}
        </template>

        <template #default>

            <div class="py-6">
                <div class="mx-auto px-4 sm:px-6 md:px-8">

                    <Tabs
                        class="mb-5"
                        :items="[
                            { key: 'general', name: __('admin::projects.tab_general'), href: $route('admin::projects.general.edit', { project: project.id }) },
                            { key: 'feeds', name: __('admin::projects.tab_feeds'), href: $route('admin::projects.feeds.index', { project: project.id }) },
                            { key: 'properties', name: __('admin::projects.tab_properties'), href: $route('admin::projects.properties.index', { project: project.id }) },
                            { key: 'realtors', name: __('admin::projects.tab_realtors'), href: $route('admin::projects.realtors.edit', { project: project.id }) },
                            { key: 'open-house', name: __('admin::projects.tab_open_house'), href: $route('admin::projects.open-house.edit', { project: project.id }) },
                            { key: 'table-data', name: __('admin::projects.tab_table_data'), href: $route('admin::projects.table-data.edit', { project: project.id }) },
                            { key: 'integrations', name: __('admin::projects.tab_integrations'), href: $route('admin::projects.integrations.edit', { project: project.id }) },
                            { key: 'documentation', name: __('admin::projects.tab_documentation') + ' V1', href: $route('admin::projects.documentation.show', { project: project.id }) },
                        ]"
                        :current="currentTab"
                    />

                    <slot />

                </div>
            </div>

        </template>

    </DefaultLayout>
</template>

<script>
    import DefaultLayout from "@/Layouts/DefaultLayout";
    import {ChevronRightIcon} from "@heroicons/vue/outline";
    import Tabs from "@/Components/Tabs";

    export default {
        components: {
            Tabs,
            ChevronRightIcon,
            DefaultLayout,
        },
        props: {
            project: Object,
            currentTab: String,
        },
    }
</script>
